import { render, staticRenderFns } from "./UpdateConnectionModal.vue?vue&type=template&id=89ed55f2&"
import script from "./UpdateConnectionModal.vue?vue&type=script&lang=js&"
export * from "./UpdateConnectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports